/* ClassyPod: limit product gallery to 6 images per selected variant.
   Rule: the selected variant's featured image first, then fill with the
   remaining images (original order) up to 6 total. Everything else is hidden
   in the main gallery + thumbnails. Liquid keeps the same compact media set
   in the zoom modal, including every image needed for variant switching. */
(function () {
  'use strict';
  var MAX = 6;

  function mediaIdOf(attr) {
    if (!attr) return null;
    var i = attr.lastIndexOf('-');
    return i === -1 ? attr : attr.slice(i + 1);
  }

  function getVariantsFor(picker) {
    var script = picker.querySelector('script[type="application/json"]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function getVariantGalleryMap(gallery) {
    var script = gallery.querySelector('script[data-cp-variant-gallery-map]');
    if (!script) return null;
    try {
      var map = JSON.parse(script.textContent);
      return map && typeof map === 'object' ? map : null;
    } catch (e) {
      return null;
    }
  }

  function currentVariantId(sectionId) {
    var input = document.querySelector(
      '#product-form-' + sectionId + ' input[name="id"], form[id^="product-form-' + sectionId + '"] input[name="id"]'
    );
    return input ? String(input.value) : null;
  }

  function primePreferredMedia(slide) {
    if (!slide) return;
    var images = slide.querySelectorAll('img');
    Array.prototype.forEach.call(images, function (image) {
      image.loading = 'eager';
      image.setAttribute('fetchpriority', 'high');
      // decode() also prompts browsers to fetch an image that was initially
      // below the native lazy-loading threshold before this variant was picked.
      if (!image.complete && typeof image.decode === 'function') {
        image.decode().catch(function () {});
      }
    });
  }

  function applyToGallery(gallery, featuredMediaId, selectedVariantId) {
    var slides = Array.prototype.slice.call(
      gallery.querySelectorAll('li.product__media-item[data-media-id]')
    );
    if (!slides.length) return null;

    // Current media IDs. Dawn may prepend a selected variant slide later; the
    // original fallback is stored separately below so that reorder is harmless.
    var ids = slides.map(function (li) {
      return mediaIdOf(li.getAttribute('data-media-id'));
    });

    // Some imported products have variants without featured_media. Dawn still
    // renders a sensible primary slide for those products, so remember that
    // server-selected slide and use it whenever the selected variant has no
    // media of its own. Keeping the value on the gallery also makes switching
    // from a media-backed variant back to a media-less variant deterministic.
    var fallbackMediaId = gallery.getAttribute('data-cp-fallback-media-id');
    if (!fallbackMediaId) {
      var initialActive = gallery.querySelector(
        'li.product__media-item.is-active[data-media-id]'
      );
      var fallbackSlide = initialActive || slides[0];
      fallbackMediaId = mediaIdOf(fallbackSlide.getAttribute('data-media-id'));
      if (fallbackMediaId) {
        gallery.setAttribute('data-cp-fallback-media-id', fallbackMediaId);
      }
    }

    var allowed = [];
    var variantGalleryMap = getVariantGalleryMap(gallery);
    var mappedMedia =
      variantGalleryMap && selectedVariantId
        ? variantGalleryMap[String(selectedVariantId)]
        : null;

    if (Array.isArray(mappedMedia) && mappedMedia.length) {
      mappedMedia.forEach(function (mediaId) {
        var id = String(mediaId);
        if (allowed.length < MAX && ids.indexOf(id) !== -1 && allowed.indexOf(id) === -1) {
          allowed.push(id);
        }
      });

      // Older imported products may have only one exact, variant-specific
      // main image mapped. Keep that image first, then show up to five
      // unassigned product-detail images so the gallery never looks empty.
      // Media assigned to another variant stays excluded, preventing a
      // different finish or gift-box main image from appearing.
      for (var j = 0; j < ids.length && allowed.length < MAX; j++) {
        if (slides[j].classList.contains('product__media-item--variant')) continue;
        if (allowed.indexOf(ids[j]) === -1) allowed.push(ids[j]);
      }
    } else {
      if (featuredMediaId && ids.indexOf(String(featuredMediaId)) !== -1) {
        allowed.push(String(featuredMediaId));
      } else if (fallbackMediaId && ids.indexOf(String(fallbackMediaId)) !== -1) {
        allowed.push(String(fallbackMediaId));
      }
      for (var k = 0; k < ids.length && allowed.length < MAX; k++) {
        // Other variants' featured images are hidden by Dawn and should not
        // consume one of the six visible gallery slots.
        if (slides[k].classList.contains('product__media-item--variant')) continue;
        if (allowed.indexOf(ids[k]) === -1) allowed.push(ids[k]);
      }
    }

    slides.forEach(function (li) {
      var id = mediaIdOf(li.getAttribute('data-media-id'));
      Array.prototype.forEach.call(li.querySelectorAll('img[fetchpriority="high"]'), function (image) {
        image.removeAttribute('fetchpriority');
      });
      // Dawn hides variant media unless it is the first DOM item. Variant
      // changes can prepend another slide, so explicitly show the preferred
      // media instead of relying on the fragile :first-child rule.
      if (allowed.indexOf(id) === -1) {
        li.style.display = 'none';
      } else {
        li.style.display = id === allowed[0] ? 'block' : '';
      }
    });

    var thumbs = gallery.querySelectorAll('.thumbnail-list__item');
    Array.prototype.forEach.call(thumbs, function (li) {
      var target =
        li.getAttribute('data-target') ||
        (li.querySelector('[data-target]') &&
          li.querySelector('[data-target]').getAttribute('data-target'));
      var id = mediaIdOf(target);
      if (allowed.indexOf(id) === -1) {
        li.style.display = 'none';
      } else {
        li.style.display = id === allowed[0] ? 'block' : '';
      }
    });

    // The desktop thumbnail layout only displays `.is-active`. If the previous
    // active slide was hidden while changing variants, activate the preferred
    // visible slide through Dawn's gallery API so the main image cannot blank.
    var activeSlide = gallery.querySelector(
      'li.product__media-item.is-active[data-media-id]'
    );
    var activeId = activeSlide
      ? mediaIdOf(activeSlide.getAttribute('data-media-id'))
      : null;
    if (allowed.length && activeId !== allowed[0]) {
      var preferredSlide = slides.filter(function (li) {
        return mediaIdOf(li.getAttribute('data-media-id')) === allowed[0];
      })[0];
      if (preferredSlide) {
        primePreferredMedia(preferredSlide);
        var targetMediaId = preferredSlide.getAttribute('data-media-id');
        if (typeof gallery.setActiveMedia === 'function') {
          gallery.setActiveMedia(targetMediaId, false);
        } else {
          slides.forEach(function (li) {
            li.classList.remove('is-active');
          });
          preferredSlide.classList.add('is-active');
        }
      }
    } else if (allowed.length) {
      primePreferredMedia(activeSlide);
    }

    return allowed.length ? allowed[0] : null;
  }

  function applySection(sectionId, variants) {
    var featured = null;
    var selectedVariantId = currentVariantId(sectionId);
    if (variants) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === selectedVariantId) {
          if (variants[i].featured_media) featured = variants[i].featured_media.id;
          break;
        }
      }
    }
    var galleries = document.querySelectorAll('media-gallery[id^="MediaGallery-' + sectionId + '"]');
    var preferredMediaId = null;
    Array.prototype.forEach.call(galleries, function (g) {
      var galleryPreferredMediaId = applyToGallery(g, featured, selectedVariantId);
      if (!preferredMediaId && galleryPreferredMediaId) {
        preferredMediaId = galleryPreferredMediaId;
      }
    });

    // Dawn prepends media-backed variants in the modal, but a variant without
    // featured media needs the deterministic fallback moved back to the front.
    // Otherwise its modal image retains the variant-only CSS hidden state.
    if (preferredMediaId) {
      var modalContent = document.querySelector(
        '#ProductModal-' + sectionId + ' .product-media-modal__content'
      );
      var primaryGallery = galleries[0];
      var variantGalleryMap = primaryGallery ? getVariantGalleryMap(primaryGallery) : null;
      var mappedMedia =
        variantGalleryMap && selectedVariantId
          ? variantGalleryMap[String(selectedVariantId)]
          : null;
      var allowedModalIds = Array.isArray(mappedMedia)
        ? mappedMedia.slice(0, MAX).map(String)
        : null;
      if (modalContent && allowedModalIds) {
        Array.prototype.forEach.call(modalContent.querySelectorAll('[data-media-id]'), function (media) {
          media.style.display = allowedModalIds.indexOf(String(media.getAttribute('data-media-id'))) === -1 ? 'none' : '';
        });
      }
      var modalMedia = modalContent
        ? modalContent.querySelector('[data-media-id="' + preferredMediaId + '"]')
        : null;
      if (modalMedia && modalContent.firstElementChild !== modalMedia) {
        modalContent.prepend(modalMedia);
      }
    }
  }

  function init() {
    var pickers = document.querySelectorAll('variant-radios[data-section], variant-selects[data-section]');
    var covered = {};

    Array.prototype.forEach.call(pickers, function (picker) {
      var sectionId = picker.getAttribute('data-section');
      var variants = getVariantsFor(picker);
      covered[sectionId] = true;

      var run = function () {
        applySection(sectionId, variants);
      };
      picker.addEventListener('change', function () {
        // let the theme update the hidden variant input first
        setTimeout(run, 80);
        setTimeout(run, 350);
      });
      run();
    });

    // Galleries without a variant picker (single-variant products): first 6 only
    Array.prototype.forEach.call(document.querySelectorAll('media-gallery[id^="MediaGallery-"]'), function (g) {
      var id = g.id.replace('MediaGallery-', '');
      var owned = Object.keys(covered).some(function (s) {
        return id.indexOf(s) === 0;
      });
      if (!owned) applyToGallery(g, null, null);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
